<template lang="pug">
page(
    main-title="Профиль",
    main-description="Редактирование данных о Вас"
)
    .panel
        .panel-body
            .row
                .col-md-2
                    #fix-height-div.form-group
                        v-select-styled(
                            v-model="profile.sex",
                            :searchable="false",
                            :clearable="false",
                            :options="sexChoice") 

                .col-md-5
                    .form-group(:class="{'has-error': !validation.first_name.valid}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(type="text", 
                                  required="",
                                  v-model="profile.first_name",
                                  @focus="validation.first_name.valid = true")
                            span.field-underline
                            label Имя
                        span.help-block.error(v-if='!validation.first_name.valid') 
                            | {{ validation.first_name.message }}

                .col-md-5
                    .form-group(:class="{'has-error': !validation.last_name.valid}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(type="text", 
                                  required="",
                                  v-model="profile.last_name",
                                  @focus="validation.last_name.valid = true")
                            span.field-underline
                            label Фамилия
                        span.help-block.error(v-if='!validation.last_name.valid')
                            | {{ validation.last_name.message }}
            .row
                .col-md-2
                .col-md-5
                    .form-group(:class="{'has-error': !validation.email.valid}")
                        .vfl-field.input-group(style="width: 100%;")
                            input(type='text', v-model='profile.email', required="",
                                  @focus="validation.email.valid = true")
                            span.field-underline
                            label Email
                        span.help-block.error(v-if='!validation.email.valid')
                            | {{ validation.email.message }}
                .col-md-5
                    .form-group(:class="{'has-error': !validation.phone.valid}")
                        .vfl-field.input-group(style="width: 100%;")
                            the-mask(type='tel', mask="+7 (###) ###-##-##", v-model='profile.phone', 
                                     required="", 
                                     @focus.native="phoneFocus")
                            span.field-underline
                            label Номер телефона
                        span.help-block.error(v-if='!validation.phone.valid')
                            | {{ validation.phone.message }}

            .row
                .col-md-12 Данные вашей компании для выставления счетов<br /><Br />
            .row
                .col-md-2
                .col-md-10
                    .form-group(:class="")
                        .vfl-field.input-group(style="width: 100%;")
                            input(type='text', v-model='profile.legal_entity', required="")
                            span.field-underline
                            label Наименование юр. лица
            .row
                .col-md-2
                .col-md-10
                    .form-group(:class="")
                        .vfl-field.input-group(style="width: 100%;")
                            input(type='text', v-model='profile.legal_address', required="")
                            span.field-underline
                            label Юридический адрес
            .row
                .col-md-2
                .col-md-5
                    .form-group(:class="")
                        .vfl-field.input-group(style="width: 100%;")
                            input(type='text', v-model='profile.legal_inn', required="")
                            span.field-underline
                            label ИНН
                .col-md-5
                    .form-group(:class="")
                        .vfl-field.input-group(style="width: 100%;")
                            input(type='text', v-model='profile.legal_kpp', required="")
                            span.field-underline
                            label КПП

            .row(v-if="withPassRecovering")
                .col-md-2
                .col-md-5
                    .form-group(:class="{'has-error': !passwordValid}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(type="password", 
                                  required="",
                                  v-model="password",
                                  @blur="passwordChanged = true",
                                  @focus="passwordChanged = false")
                            span.field-underline
                            label Новый пароль
                                span(v-if="passwordChanged && tooShortPassword") <b> – минимум 6 символов </b>
                .col-md-5
                    .form-group(:class="{'has-error': passwordCheckChanged && passwordsNotEqual}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(type="password", 
                                  required="",
                                  v-model="passwordCheck",
                                  @blur="passwordCheckChanged = true")
                            span.field-underline
                            label Ещё разок новый пароль
                                span(v-if='passwordCheckChanged && passwordsNotEqual') <b> – пароли не совпадают</b>
            button.btn.btn-o.btn-primary(
                v-if="profileChanged", 
                @click.prevent="save",
                style="margin-right: 4px;"
            ) Сохранить
            button.btn.btn-o.btn-default(
                v-if="!withPassRecovering",
                @click="withPassRecovering = true"
            ) Сменить пароль
            button.btn.btn-o.btn-primary.pull-right(
                v-if="profileChanged", 
                @click.prevent="discard"
            ) Отмена
</template>

<script>
import { mapState } from 'vuex';

import vSelectStyled from '@/components/vSelectStyled';

const sexChoice = [{name: 'Дорогой', id: 'м'}, {name: 'Дорогая', id: 'ж'}];

export default {
    name: 'UserInfo',
    components: {vSelectStyled},
    methods: {
        save() {
            if (this.validate()) {
                this.profile.email = this.profile.email.trim();

                this.$store.dispatch('saveProfile', {
                    ...this.profile,
                    sex: this.profile.sex.id,
                    password: this.password
                }).then(() => {
                    console.log(this.profile);
                    this.resetRecovering();
                }).catch(({errors}) => {
                    this.errors = errors;
                    this.markInvalid();
                });
            }
        },
        validate() {
            let valid = true;

            for (let field in this.validation) {
                if (!this.profile[field]) {
                    this.validation[field].valid = false;
                    this.validation[field].message = 'Обязательно для заполнения';
                    valid = false;
                }
            }
            if (this.profile.phone && this.profile.phone.length !== 10) {
                this.validation.phone.valid = false;
                this.validation.phone.message = 'Пожалуйста, укажите верный номер телефона';
                valid = false;
            }

            if (this.withPassRecovering) {
                this.passwordChanged = true;
                this.passwordCheckChanged = true;
                return valid && !this.passwordsNotEqual && !this.tooShortPassword;
            }
            return valid;
        },
        markInvalid() {
            for (let error of this.errors) {
                this.validation[error.field].valid = false;
                this.validation[error.field].message = error.message;
            }
        },
        discard() {
            this.profile = this.getProfileFromState();

            this.resetRecovering();
        },
        phoneFocus() {
            this.validation.phone.valid = true;
            if (!this.profile.phone) this.profile.phone = '+7 (';
        },
        getProfileFromState() {
            let profile = {...this.$store.state.users.profile};
            profile.sex = sexChoice.find((i) => i.id === profile.sex);

            if (profile.phone && profile.phone[0] === '7') {
                profile.phone = profile.phone.slice(1);
            }
            return profile;
        },
        resetRecovering() {
            this.withPassRecovering = false;
            this.passwordChanged = this.passwordCheckChanged = false;
            this.password = this.passwordCheck = null;
        }
    },
    computed: {
        profileChanged() {
            let profileState = this.$store.state.users.profile;
            for (let key in this.profile) {
                if (key === 'sex') {
                    if (this.profile.sex && this.profile[key].id &&
                            this.profile.sex.id !== profileState.sex) {
                        return true;
                    }
                } else if (key === 'phone') {
                    if (`7${this.profile.phone}` !== profileState.phone) {
                        return true;
                    }
                } else {
                    if (this.profile[key] !== profileState[key]) {
                        return true;
                    }
                }
            }
            return this.withPassRecovering;
        },
        passwordsNotEqual() {
            return this.password !== this.passwordCheck;
        },
        tooShortPassword() {
            return !this.password || this.password.length < 6;
        },
        passwordValid() {
            return !(
                (this.passwordChanged && this.tooShortPassword) ||
                (this.passwordChanged && this.passwordCheckChanged && this.passwordsNotEqual)
            );
        }
    },
    data() {
        // let profile = this.getProfileFromState()
        // let profile = {...this.$store.state.users.profile}
        // profile.sex = sexChoice.find((i) => i.id === profile.sex)

        this.$store.state.users.profilePromise.then(() => {
            this.profile = this.getProfileFromState();
        });

        return {
            profile: this.getProfileFromState(),
            sexChoice,

            withPassRecovering: false,
            password: null,
            passwordCheck: null,
            passwordChanged: false,
            passwordCheckChanged: false,

            validation: {
                first_name: {valid: true, message: null},
                last_name: {valid: true, message: null},
                email: {valid: true, message: null},
                phone: {valid: true, message: null}
            },

            errors: []
        };
    }
};
</script>

<style>
#fix-height-div .dropdown-toggle {
    max-height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserInfo.vue